import {  NgModule } from '@angular/core';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
// import { MatMomentDateModule } from '@angular/material-moment-adapter' // Removed
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MaterialModule } from 'digital-core';
import { MatIconModule } from '@angular/material/icon';

const IMPORTS = [
  MaterialModule,
  MatExpansionModule,
  MatSnackBarModule,
  // MatMomentDateModule removed
  MatSortModule,
  MatStepperModule,
  MatMenuModule,
  MatPaginatorModule,
  MatToolbarModule,
  MatCardModule,
  MatListModule,
  MatButtonToggleModule,
  MatTableModule,
  MatButtonModule,
  MatDividerModule,
  MatTabsModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatIconModule,
];

@NgModule({
  declarations: [],
  imports: [
    ...IMPORTS
  ],
  exports: [
    ...IMPORTS
  ],
 
})
export class GspMaterialModule { }
